import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext(null);

const translations = {
  ko: {
    appName: 'OneJob',
    home: '홈',
    login: '로그인',
    logout: '로그아웃',
    myPage: '마이페이지',
    search: '검색',
    searchPlaceholder: '직종, 지역, 키워드 검색...',
    jobList: '채용공고',
    postJob: '공고 등록',
    apply: '지원하기',
    bookmark: '북마크',
    myApplications: '내 지원내역',
    myBookmarks: '내 북마크',
    myJobs: '내 공고',
    hourlyWage: '시급',
    won: '원',
    location: '근무지',
    workDays: '근무요일',
    workHours: '근무시간',
    category: '업종',
    visaType: '가능 비자',
    koreanLevel: '한국어 수준',
    deadline: '마감일',
    companyName: '회사명',
    title: '제목',
    description: '상세설명',
    viewCount: '조회수',
    noResults: '검색 결과가 없습니다',
    loginWith: '로그인',
    selectLanguage: '언어 선택',
    allCategories: '전체',
    restaurant: '음식점',
    cafe: '카페',
    store: '매장',
    factory: '공장',
    office: '사무',
    teaching: '교육',
    other: '기타',
    detectLocation: '내 위치 찾기',
    locating: '위치 찾는 중...',
    nearbyJobs: '내 주변',
    originalKorean: '원문 (한국어)',
    translatedContent: '번역',
    resume: '이력서',
    myResumes: '내 이력서',
    createResume: '이력서 작성',
    editResume: '이력서 수정',
    introduction: '자기소개',
    education: '학력',
    experience: '경력',
    skills: '보유 기술',
    languageSkills: '언어 능력',
    recentlyViewed: '최근 본 공고',
    similarJobs: '비슷한 공고',
    withdraw: '지원 취소',
    accept: '합격',
    reject: '불합격',
    repost: '재등록',
    sortLatest: '최신순',
    sortWage: '시급 높은순',
    sortDeadline: '마감 임박순',
    sortPopular: '인기순',
    advancedFilter: '상세 필터',
    wageRange: '시급 범위',
    minWage: '최소 시급',
    maxWage: '최대 시급',
    applicants: '지원자',
    closed: '마감됨',
    viewDetail: '상세보기',
    noResumes: '등록된 이력서가 없습니다',
    defaultResume: '기본 이력서',
    setDefault: '기본으로 설정',
    selectResume: '이력서 선택',
    coverLetter: '자기소개서',
    applicationCount: '지원자 수',
    pageNotFound: '페이지를 찾을 수 없습니다',
    goHome: '홈으로 돌아가기',
    confirmWithdraw: '정말 지원을 취소하시겠습니까?',
    confirmDelete: '정말 삭제하시겠습니까?',
    translationNotAvailable: '번역을 사용할 수 없습니다. 한국어 원문을 표시합니다.',
    notifications: '알림',
  },
  en: {
    appName: 'OneJob',
    home: 'Home',
    login: 'Login',
    logout: 'Logout',
    myPage: 'My Page',
    search: 'Search',
    searchPlaceholder: 'Search by job type, location, keyword...',
    jobList: 'Job Listings',
    postJob: 'Post Job',
    apply: 'Apply',
    bookmark: 'Bookmark',
    myApplications: 'My Applications',
    myBookmarks: 'My Bookmarks',
    myJobs: 'My Posts',
    hourlyWage: 'Hourly Wage',
    won: 'KRW',
    location: 'Location',
    workDays: 'Work Days',
    workHours: 'Work Hours',
    category: 'Category',
    visaType: 'Visa Type',
    koreanLevel: 'Korean Level',
    deadline: 'Deadline',
    companyName: 'Company',
    title: 'Title',
    description: 'Description',
    viewCount: 'Views',
    noResults: 'No results found',
    loginWith: 'Login',
    selectLanguage: 'Language',
    allCategories: 'All',
    restaurant: 'Restaurant',
    cafe: 'Cafe',
    store: 'Store',
    factory: 'Factory',
    office: 'Office',
    teaching: 'Teaching',
    other: 'Other',
    detectLocation: 'Find my location',
    locating: 'Finding location...',
    nearbyJobs: 'Nearby',
    originalKorean: 'Original (Korean)',
    translatedContent: 'Translation',
    resume: 'Resume',
    myResumes: 'My Resumes',
    createResume: 'Create Resume',
    editResume: 'Edit Resume',
    introduction: 'Introduction',
    education: 'Education',
    experience: 'Experience',
    skills: 'Skills',
    languageSkills: 'Languages',
    recentlyViewed: 'Recently Viewed',
    similarJobs: 'Similar Jobs',
    withdraw: 'Withdraw',
    accept: 'Accept',
    reject: 'Reject',
    repost: 'Repost',
    sortLatest: 'Latest',
    sortWage: 'Highest Wage',
    sortDeadline: 'Deadline',
    sortPopular: 'Popular',
    advancedFilter: 'Filters',
    wageRange: 'Wage Range',
    minWage: 'Min Wage',
    maxWage: 'Max Wage',
    applicants: 'Applicants',
    closed: 'Closed',
    viewDetail: 'View Detail',
    noResumes: 'No resumes yet',
    defaultResume: 'Default Resume',
    setDefault: 'Set as Default',
    selectResume: 'Select Resume',
    coverLetter: 'Cover Letter',
    applicationCount: 'Applicants',
    pageNotFound: 'Page not found',
    goHome: 'Go Home',
    confirmWithdraw: 'Are you sure you want to withdraw?',
    confirmDelete: 'Are you sure you want to delete?',
    translationNotAvailable: 'Translation not available. Showing original Korean text.',
    notifications: 'Notifications',
  },
  vi: {
    appName: 'OneJob',
    home: 'Trang chủ',
    login: 'Đăng nhập',
    logout: 'Đăng xuất',
    myPage: 'Trang cá nhân',
    search: 'Tìm kiếm',
    searchPlaceholder: 'Tìm theo loại công việc, vị trí...',
    jobList: 'Danh sách việc làm',
    postJob: 'Đăng việc',
    apply: 'Ứng tuyển',
    bookmark: 'Đánh dấu',
    myApplications: 'Đơn ứng tuyển',
    myBookmarks: 'Đánh dấu của tôi',
    myJobs: 'Bài đăng của tôi',
    hourlyWage: 'Lương/giờ',
    won: 'KRW',
    location: 'Địa điểm',
    workDays: 'Ngày làm',
    workHours: 'Giờ làm',
    category: 'Ngành nghề',
    visaType: 'Loại visa',
    koreanLevel: 'Trình độ tiếng Hàn',
    deadline: 'Hạn nộp',
    companyName: 'Công ty',
    title: 'Tiêu đề',
    description: 'Mô tả',
    viewCount: 'Lượt xem',
    noResults: 'Không tìm thấy kết quả',
    loginWith: 'Đăng nhập',
    selectLanguage: 'Ngôn ngữ',
    allCategories: 'Tất cả',
    restaurant: 'Nhà hàng',
    cafe: 'Quán cà phê',
    store: 'Cửa hàng',
    factory: 'Nhà máy',
    office: 'Văn phòng',
    teaching: 'Giảng dạy',
    other: 'Khác',
    detectLocation: 'Tìm vị trí',
    locating: 'Đang tìm vị trí...',
    nearbyJobs: 'Gần đây',
    originalKorean: 'Bản gốc (Tiếng Hàn)',
    translatedContent: 'Bản dịch',
    resume: 'Hồ sơ',
    myResumes: 'Hồ sơ của tôi',
    createResume: 'Tạo hồ sơ',
    editResume: 'Sửa hồ sơ',
    introduction: 'Giới thiệu',
    education: 'Học vấn',
    experience: 'Kinh nghiệm',
    skills: 'Kỹ năng',
    languageSkills: 'Ngôn ngữ',
    recentlyViewed: 'Đã xem gần đây',
    similarJobs: 'Việc tương tự',
    withdraw: 'Rút đơn',
    accept: 'Chấp nhận',
    reject: 'Từ chối',
    repost: 'Đăng lại',
    sortLatest: 'Mới nhất',
    sortWage: 'Lương cao nhất',
    sortDeadline: 'Sắp hết hạn',
    sortPopular: 'Phổ biến',
    advancedFilter: 'Bộ lọc',
    wageRange: 'Mức lương',
    minWage: 'Lương tối thiểu',
    maxWage: 'Lương tối đa',
    applicants: 'Ứng viên',
    closed: 'Đã đóng',
    viewDetail: 'Xem chi tiết',
    noResumes: 'Chưa có hồ sơ',
    defaultResume: 'Hồ sơ mặc định',
    setDefault: 'Đặt mặc định',
    selectResume: 'Chọn hồ sơ',
    coverLetter: 'Thư xin việc',
    applicationCount: 'Số ứng viên',
    pageNotFound: 'Không tìm thấy trang',
    goHome: 'Về trang chủ',
    confirmWithdraw: 'Bạn có chắc muốn rút đơn?',
    confirmDelete: 'Bạn có chắc muốn xóa?',
    translationNotAvailable: 'Bản dịch không có sẵn. Hiển thị văn bản gốc tiếng Hàn.',
    notifications: 'Thông báo',
  },
  km: {
    appName: 'OneJob',
    home: 'ទំព័រដើម',
    login: 'ចូល',
    logout: 'ចាកចេញ',
    myPage: 'ទំព័ររបស់ខ្ញុំ',
    search: 'ស្វែងរក',
    searchPlaceholder: 'ស្វែងរកតាមប្រភេទការងារ ទីតាំង...',
    jobList: 'បញ្ជីការងារ',
    postJob: 'បង្ហោះការងារ',
    apply: 'ដាក់ពាក្យ',
    bookmark: 'ចំណាំ',
    myApplications: 'ពាក្យស្នើសុំរបស់ខ្ញុំ',
    myBookmarks: 'ចំណាំរបស់ខ្ញុំ',
    myJobs: 'ការបង្ហោះរបស់ខ្ញុំ',
    hourlyWage: 'ប្រាក់ឈ្នួល/ម៉ោង',
    won: 'វ៉ុន',
    location: 'ទីតាំង',
    workDays: 'ថ្ងៃធ្វើការ',
    workHours: 'ម៉ោងធ្វើការ',
    category: 'ប្រភេទ',
    visaType: 'ប្រភេទទិដ្ឋាការ',
    koreanLevel: 'កម្រិតភាសាកូរ៉េ',
    deadline: 'ថ្ងៃផុតកំណត់',
    companyName: 'ក្រុមហ៊ុន',
    title: 'ចំណងជើង',
    description: 'ការពិពណ៌នា',
    viewCount: 'ចំនួនមើល',
    noResults: 'រកមិនឃើញលទ្ធផល',
    loginWith: 'ចូល',
    selectLanguage: 'ភាសា',
    allCategories: 'ទាំងអស់',
    restaurant: 'ភោជនីយដ្ឋាន',
    cafe: 'ហាងកាហ្វេ',
    store: 'ហាង',
    factory: 'រោងចក្រ',
    office: 'ការិយាល័យ',
    teaching: 'ការបង្រៀន',
    other: 'ផ្សេងទៀត',
    detectLocation: 'រកទីតាំង',
    locating: 'កំពុងរកទីតាំង...',
    nearbyJobs: 'នៅជិត',
    originalKorean: 'ភាសាដើម (កូរ៉េ)',
    translatedContent: 'បកប្រែ',
    resume: 'ប្រវត្តិរូប',
    myResumes: 'ប្រវត្តិរូបរបស់ខ្ញុំ',
    createResume: 'បង្កើតប្រវត្តិរូប',
    editResume: 'កែប្រវត្តិរូប',
    introduction: 'ការណែនាំខ្លួន',
    education: 'ការអប់រំ',
    experience: 'បទពិសោធន៍',
    skills: 'ជំនាញ',
    languageSkills: 'ភាសា',
    recentlyViewed: 'បានមើលថ្មីៗ',
    similarJobs: 'ការងារស្រដៀង',
    withdraw: 'ដកពាក្យ',
    accept: 'ទទួល',
    reject: 'បដិសេធ',
    repost: 'បង្ហោះឡើងវិញ',
    sortLatest: 'ថ្មីបំផុត',
    sortWage: 'ប្រាក់ខែខ្ពស់',
    sortDeadline: 'ជិតផុតកំណត់',
    sortPopular: 'ពេញនិយម',
    advancedFilter: 'តម្រង',
    wageRange: 'ចន្លោះប្រាក់ឈ្នួល',
    minWage: 'អប្បបរមា',
    maxWage: 'អតិបរមា',
    applicants: 'អ្នកដាក់ពាក្យ',
    closed: 'បិទ',
    viewDetail: 'មើលលម្អិត',
    noResumes: 'មិនមានប្រវត្តិរូប',
    defaultResume: 'ប្រវត្តិរូបលំនាំដើម',
    setDefault: 'កំណត់លំនាំដើម',
    selectResume: 'ជ្រើសប្រវត្តិរូប',
    coverLetter: 'លិខិតណែនាំ',
    applicationCount: 'ចំនួនអ្នកដាក់ពាក្យ',
    pageNotFound: 'រកទំព័រមិនឃើញ',
    goHome: 'ទៅទំព័រដើម',
    confirmWithdraw: 'ពិតជាចង់ដកពាក្យមែនទេ?',
    confirmDelete: 'ពិតជាចង់លុបមែនទេ?',
    translationNotAvailable: 'ការបកប្រែមិនមាន។ បង្ហាញអត្ថបទភាសាកូរ៉េដើម។',
    notifications: 'ការជូនដំណឹង',
  },
  uz: {
    appName: 'OneJob',
    home: 'Bosh sahifa',
    login: 'Kirish',
    logout: 'Chiqish',
    myPage: 'Mening sahifam',
    search: 'Qidirish',
    searchPlaceholder: 'Ish turi, joylashuv bo\'yicha qidirish...',
    jobList: 'Ish e\'lonlari',
    postJob: 'E\'lon berish',
    apply: 'Ariza berish',
    bookmark: 'Saqlash',
    myApplications: 'Mening arizalarim',
    myBookmarks: 'Saqlangan',
    myJobs: 'Mening e\'lonlarim',
    hourlyWage: 'Soatlik ish haqi',
    won: 'KRW',
    location: 'Joylashuv',
    workDays: 'Ish kunlari',
    workHours: 'Ish soatlari',
    category: 'Kategoriya',
    visaType: 'Viza turi',
    koreanLevel: 'Koreys tili darajasi',
    deadline: 'Muddat',
    companyName: 'Kompaniya',
    title: 'Sarlavha',
    description: 'Tavsif',
    viewCount: 'Ko\'rishlar',
    noResults: 'Natija topilmadi',
    loginWith: 'Kirish',
    selectLanguage: 'Til',
    allCategories: 'Barchasi',
    restaurant: 'Restoran',
    cafe: 'Kafe',
    store: 'Do\'kon',
    factory: 'Zavod',
    office: 'Ofis',
    teaching: 'Ta\'lim',
    other: 'Boshqa',
    detectLocation: 'Joylashuvni aniqlash',
    locating: 'Joylashuv aniqlanmoqda...',
    nearbyJobs: 'Yaqin atrofda',
    originalKorean: 'Asl nusxa (Koreys)',
    translatedContent: 'Tarjima',
    resume: 'Rezyume',
    myResumes: 'Mening rezyumem',
    createResume: 'Rezyume yaratish',
    editResume: 'Rezyumeni tahrirlash',
    introduction: 'O\'zini tanishtirish',
    education: 'Ta\'lim',
    experience: 'Tajriba',
    skills: 'Ko\'nikmalar',
    languageSkills: 'Tillar',
    recentlyViewed: 'Yaqinda ko\'rilgan',
    similarJobs: 'O\'xshash ishlar',
    withdraw: 'Arizani qaytarish',
    accept: 'Qabul qilish',
    reject: 'Rad etish',
    repost: 'Qayta e\'lon',
    sortLatest: 'Eng yangi',
    sortWage: 'Eng yuqori ish haqi',
    sortDeadline: 'Muddati tugayotgan',
    sortPopular: 'Mashhur',
    advancedFilter: 'Filtrlar',
    wageRange: 'Ish haqi oralig\'i',
    minWage: 'Minimal',
    maxWage: 'Maksimal',
    applicants: 'Arizachilar',
    closed: 'Yopilgan',
    viewDetail: 'Batafsil',
    noResumes: 'Rezyume yo\'q',
    defaultResume: 'Asosiy rezyume',
    setDefault: 'Asosiy qilish',
    selectResume: 'Rezyume tanlash',
    coverLetter: 'Ariza xati',
    applicationCount: 'Arizachilar soni',
    pageNotFound: 'Sahifa topilmadi',
    goHome: 'Bosh sahifaga',
    confirmWithdraw: 'Arizani qaytarmoqchimisiz?',
    confirmDelete: 'O\'chirmoqchimisiz?',
    translationNotAvailable: 'Tarjima mavjud emas. Koreys tilidagi asl matn ko\'rsatilmoqda.',
    notifications: 'Bildirishnomalar',
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('lang') || 'ko');

  const changeLang = (newLang) => {
    setLang(newLang);
    localStorage.setItem('lang', newLang);
  };

  const t = (key) => translations[lang]?.[key] || translations['ko'][key] || key;

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function getTranslations() {
  return translations;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
}
